<div class="chat-widget">
  <!-- Cabeçalho fixo com detalhes da ordem de serviço -->
  <div class="chat-header">
    <div class="header-content">
      <div class="service-order-details" *ngIf="serviceOrderData">
        <div class="details-row">
          <div class="detail-item" *ngIf="serviceOrderData.code">
            <span class="detail-label">Código:</span>
            <span class="detail-value">{{ serviceOrderData.code }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Sistema:</span>
            <span class="detail-value">{{ serviceOrderData.system?.name || serviceOrderData.systemName || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Tipo:</span>
            <span class="detail-value">{{ getServiceOrderTypeDescription(serviceOrderData.fileType) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Cliente:</span>
            <span class="detail-value">{{ serviceOrderData.customer?.name || serviceOrderData.customerName || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Status:</span>
            <span class="detail-value status-badge" [ngClass]="'status-' + (serviceOrderData.status || 'N/A').toLowerCase()">
              {{ serviceOrderData.status || 'N/A' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Criada em:</span>
            <span class="detail-value">
              {{ serviceOrderData.createdAt | date:'dd/MM/yyyy' }} às {{ serviceOrderData.createdAt | date:'HH:mm' }}
            </span>
          </div>
        </div>
        <div class="description-section" *ngIf="getServiceOrderDescription()">
          <div class="description-header" (click)="toggleDescription()">
            <span class="detail-label">Descrição:</span>
            <span class="description-toggle" [ngClass]="{'expanded': isDescriptionExpanded}">
              <i class="arrow-icon">▼</i>
            </span>
          </div>
          <div class="description-content" [ngClass]="{'expanded': isDescriptionExpanded}">
            <p class="description-text">{{ getServiceOrderDescription() }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Corpo do chat com scroll -->
  <div class="chat-body" #chatBody>
    <div *ngFor="let message of messages; trackBy: trackByMessageId; let last = last" 
         [ngClass]="getMessageClass(message)" 
         class="message"
         [id]="'message-' + message.id"
         #lastMessage=""
         [class.last-message]="last"
         [class.system-message]="message.isBot && message.userId === 'system'">
      <div class="message-header">
        {{ getUserName(message) }}
      </div>
      <div class="message-content" [innerHTML]="formatMessageContent(message.message)"></div>
      <span class="message-time">{{ formatTimestamp(message.timestamp) }}</span>
    </div>
    
    <!-- Elemento de referência para scroll automático -->
    <div #scrollToBottom></div>
  </div>

  <!-- Rodapé do chat -->
  <div class="chat-footer">
    <input 
      [(ngModel)]="newMessage" 
      class="chat-input" 
      placeholder="Digite sua mensagem..." 
      (keyup.enter)="sendMessage()" 
      [disabled]="isSendingMessage"
    />
    <button 
      (click)="sendMessage()" 
      class="send-button" 
      [disabled]="isSendingMessage || !newMessage.trim()"
    >
      {{ isSendingMessage ? 'Enviando...' : 'Enviar' }}
    </button>
  </div>
</div>
